var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.75 28.4375H1.25C0.737499 28.4375 0.312499 28.0125 0.312499 27.5C0.312499 26.9875 0.737499 26.5625 1.25 26.5625H28.75C29.2625 26.5625 29.6875 26.9875 29.6875 27.5C29.6875 28.0125 29.2625 28.4375 28.75 28.4375Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.7253 28.4501C24.2128 28.4501 23.7878 28.0251 23.7878 27.5126V21.9376C23.7878 21.4251 24.2128 21.0001 24.7253 21.0001C25.2378 21.0001 25.6628 21.4251 25.6628 21.9376V27.5126C25.6628 28.0251 25.2503 28.4501 24.7253 28.4501Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.7501 22.875C22.7126 22.875 21.0626 21.225 21.0626 19.1875V16.35C21.0626 14.3125 22.7126 12.6625 24.7501 12.6625C26.7876 12.6625 28.4377 14.3125 28.4377 16.35V19.1875C28.4377 21.225 26.7876 22.875 24.7501 22.875ZM24.7501 14.55C23.7501 14.55 22.9376 15.3625 22.9376 16.3625V19.2C22.9376 20.2 23.7501 21.0125 24.7501 21.0125C25.7501 21.0125 26.5627 20.2 26.5627 19.2V16.3625C26.5627 15.3625 25.7501 14.55 24.7501 14.55Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8748 28.4375C17.3623 28.4375 16.9373 28.0125 16.9373 27.5V7.53754C16.9373 5.55004 16.0998 4.70001 14.1498 4.70001H6.3623C4.3998 4.70001 3.5498 5.55004 3.5498 7.53754V27.5C3.5498 28.0125 3.1248 28.4375 2.6123 28.4375C2.0998 28.4375 1.6748 28.0125 1.6748 27.5V7.53754C1.6748 4.50004 3.3373 2.82501 6.3623 2.82501H14.1498C17.1623 2.82501 18.8123 4.50004 18.8123 7.53754V27.5C18.8123 28.0125 18.3873 28.4375 17.8748 28.4375Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.4373 11.25H7.24975C6.73725 11.25 6.31225 10.825 6.31225 10.3125C6.31225 9.8 6.73725 9.375 7.24975 9.375H13.4373C13.9498 9.375 14.3748 9.8 14.3748 10.3125C14.3748 10.825 13.9498 11.25 13.4373 11.25Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.4373 15.9375H7.24975C6.73725 15.9375 6.31225 15.5125 6.31225 15C6.31225 14.4875 6.73725 14.0625 7.24975 14.0625H13.4373C13.9498 14.0625 14.3748 14.4875 14.3748 15C14.3748 15.5125 13.9498 15.9375 13.4373 15.9375Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.3125 28.4375C9.8 28.4375 9.375 28.0125 9.375 27.5V22.8125C9.375 22.3 9.8 21.875 10.3125 21.875C10.825 21.875 11.25 22.3 11.25 22.8125V27.5C11.25 28.0125 10.825 28.4375 10.3125 28.4375Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.7ae8f465646378bb06844166624c17dd.svg";
export { ForwardRef as ReactComponent };